import React, { useState } from "react";
import inhouse from "../Image/icon-inhouse 1.png";
import favorite from "../Image/icon-special 1.png";
import serchicon from "../Image/search-icon.png";
import card1 from "../Image/card1.png";
import card2 from "../Image/card2.png";
import card3 from "../Image/card3.png";
import card4 from "../Image/card4.png";
import card5 from "../Image/card5.png";
import card6 from "../Image/card6.png";
import card7 from "../Image/card8.png";
import card8 from "../Image/card9.png";
import card9 from "../Image/card10.png";
import card10 from "../Image/card11.png";
import card11 from "../Image/card12.png";
import card12 from "../Image/card13.png";
import card13 from "../Image/card14.png";
import card14 from "../Image/card15.png";
import card15 from "../Image/card16.png";
import card16 from "../Image/card17.png";
import playIcon from "../Image/playicon1.png";
import { useNavigate } from "react-router-dom";

function Card() {
  const [active, setActive] = useState("inhouse");
  const games = [
    card1,
    card2,
    card3,
    card4,
    card5,
    card6,
    card7,
    card8,
    card9,
    card10,
    card11,
    card12,
    card13,
    card14,
    card15,
    card16,
  ];
  const navigate = useNavigate();
  
  return (
    <div className="hero-section pt-4">
      <div className="container">
        <div className="d-flex justify-content-between card-section">
          <div className="toggle-box">
            <div
              className={`toggle-item ${active === "inhouse" ? "active" : ""}`}
              onClick={() => setActive("inhouse")}
            >
              <img src={inhouse} alt="" />
              Inhouse
            </div>

            <div
              className={`toggle-item ${active === "favorite" ? "active" : ""}`}
              onClick={() => setActive("favorite")}
            >
              <img src={favorite} alt="" />
              Favorite
            </div>
          </div>
          <div className="search-box">
            <img src={serchicon} alt="search" />
            <input type="text" placeholder="Search for games" />
          </div>
        </div>

        <div className="row g-3 mt-3">
          {games.map((img, index) => (
            <div
              className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6"
              key={index}
            >
              <div
                className="game-card"
                onClick={() => {
                  if (index === 10) {
                    navigate("/minegame");
                  }
                 if(index === 0){
                  navigate("/dicegame");
                 }
                 if(index === 8){
                  navigate("/Spinwheel")
                 }
                 if(index === 12){
                  navigate("/coinflip")
                 }
                }}
              >
                <img src={img} alt="" />
                {index === 2 && (
                  <div className="play-overlay">
                    <div className="play-icon">
                      <img src={playIcon} alt="play" />
                    </div>
                    <span className="play-text">Ring</span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Card;
